import React from 'react';
import { Box } from '@mui/material';
import ImageButton from './ImageButton';

// Import your custom images
import FacebookImage from '../assets/SocialMediaIcons/FBapp-01.png';
import LINEImage from '../assets/SocialMediaIcons/LINEapp-01.png';
import InstagramImage from '../assets/SocialMediaIcons/IGapp-01.png';

const SocialButtons = () => {
  return (
    <Box
      sx={{
        paddingTop: 5,  
        paddingBottom: 5,    
        display: 'flex',
        flexDirection: 'row',
        gap: 3,
      }}
    >
      <ImageButton
        url="https://www.facebook.com/hopbonpremium"
        imageSrc={FacebookImage}
        label="Facebook"
      />
      <ImageButton
        url="https://lin.ee/jFw91a9"
        imageSrc={LINEImage}
        label="LINE"
      />
      <ImageButton
        url="https://www.instagram.com/hopbon_premium/"
        imageSrc={InstagramImage}
        label="Instagram"
      />
    </Box>
  );
};

export default SocialButtons;